import http from "./http";
import Service from "../Service";

/**
 * @type IntegrationService
 */
export default class IntegrationService extends Service {
    /**
     * List all integrations
     * @param {Object} params - Query parameters
     * @returns {Promise}
     */
    list(params) {
        return http.get(`/admin/integrations`, {
            headers: this.getHeaders(),
            params,
        });
    }

    /**
     * Get a single integration by ID
     * @param {number} id - Integration ID
     * @returns {Promise}
     */
    show(id) {
        return http.get(`/admin/integrations/${id}`, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Create a new integration
     * @param {Object} data - Integration data
     * @returns {Promise}
     */
    create(data) {
        return http.post(`/admin/integrations`, data, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Update an existing integration
     * @param {number} id - Integration ID
     * @param {Object} data - Integration data
     * @returns {Promise}
     */
    update(id, data) {
        return http.put(`/admin/integrations/${id}`, data, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Patch an existing integration
     * @param {number} id - Integration ID
     * @param {Object} data - Integration data
     * @returns {Promise}
     */
    patch(id, data) {
        return http.patch(`/admin/integrations/${id}`, data, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Delete an integration
     * @param {number} id - Integration ID
     * @returns {Promise}
     */
    destroy(id) {
        return http.delete(`/admin/integrations/${id}`, {
            headers: this.getHeaders(),
        });
    }

    /**
     * Toggle integration active status
     * @param {number} id - Integration ID
     * @returns {Promise}
     */
    toggle(id) {
        return http.post(
            `/admin/integrations/${id}/toggle`,
            {},
            {
                headers: this.getHeaders(),
            }
        );
    }

    /**
     * Get integration logs
     * @param {number} id - Integration ID
     * @param {Object} params - Query parameters
     * @returns {Promise}
     */
    logs(id, params) {
        return http.get(`/admin/integrations/${id}/logs`, {
            headers: this.getHeaders(),
            params,
        });
    }

    /**
     * Get integration statistics
     * @param {number} id - Integration ID
     * @param {Object} params - Query parameters
     * @returns {Promise}
     */
    statistics(id, params) {
        return http.get(`/admin/integrations/${id}/statistics`, {
            headers: this.getHeaders(),
            params,
        });
    }
}
